import classnames from 'classnames/bind'
import React from 'react'

import { Spinner } from '@unlikelystudio/react-abstract-components'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type LoadingSectionProps = {
  className?: string
}

function LoadingSection({ className }: LoadingSectionProps) {
  return (
    <div className={cx(className, css.LoadingSection)}>
      <Spinner className={css.spinner} />
    </div>
  )
}

LoadingSection.defaultProps = {}

export default LoadingSection
